import {
    FETCH_NOTIFICATIONS_REQUEST,
    FETCH_NOTIFICATIONS_SUCCESS,
    FETCH_NOTIFICATIONS_FAILURE,

    READ_NOTIFICATION_REQUEST,
    UNREAD_NOTIFICATION_REQUEST,
    READ_ALL_NOTIFICATIONS_REQUEST
} from './Types';

import axios, { CancelTokenSource } from 'axios';
import { Notification } from './notificationTypes';

let fetchNotificationsSource: CancelTokenSource | null;

const fetchNotifications = () => ({ type: FETCH_NOTIFICATIONS_REQUEST });
const fetchNotificationsSuccess = (notifications: Notification[]) => ({ type: FETCH_NOTIFICATIONS_SUCCESS, notifications });
const fetchNotificationsError = (error: any) => ({ type: FETCH_NOTIFICATIONS_FAILURE, error });
const readNotification = (id:(string|number)) => ({ type: READ_NOTIFICATION_REQUEST, read: true, id });
const unreadNotification = (id:(string|number)) => ({ type: UNREAD_NOTIFICATION_REQUEST, read: false, id });
const readAllNotifications = () => ({ type: READ_ALL_NOTIFICATIONS_REQUEST });

// Could have used the ping code but a websocket is probably better. See https://dev.to/aduranil/how-to-use-websockets-with-redux-a-step-by-step-guide-to-writing-understanding-connecting-socket-middleware-to-your-project-km3
export const fetchNotificationsAsync = () => {
    return (dispatch:(dispatch: any) => Promise<void>) => {
        fetchNotificationsSource && fetchNotificationsSource.cancel('Cancelling already running request');
        dispatch(fetchNotifications());
        return axios.get('/api/notifications', {
            cancelToken: (fetchNotificationsSource = axios.CancelToken.source()).token
        }).then(response => {
            fetchNotificationsSource = null;
            dispatch(fetchNotificationsSuccess(response.data));
        }).catch(error => {
            fetchNotificationsSource = null;
            if (axios.isCancel(error)) {
                console.log('cancel', error);
            } else {
                dispatch(fetchNotificationsError(error.response));
                console.error(error);
            }
        });
    };
};

// When marking notifications as read/unread, don't care so much about ensuring it done asynchronously with success and error actions
// Failing to mark something as read/unread shouldn't need a warning for the user, worse case when they next check there is no affect
export const readNotificationAsync = (id:(string|number)) => {
    return (dispatch:(dispatch: any) => Promise<void>) => {
        dispatch(readNotification(id));
        return axios.patch(`/api/notifications/${id}/read`)
            .catch(error => {
                console.error(error);
            });
    };
};

export const unreadNotificationAsync = (id:(string|number)) => {
    return (dispatch:(dispatch: any) => Promise<void>) => {
        dispatch(unreadNotification(id));
        return axios.patch(`/api/notifications/${id}/unread`)
            .catch(error => {
                console.error(error);
            });
    };
};

export const readAllNotificationsAsync = () => {
    return (dispatch:(dispatch: any) => Promise<void>) => {
        dispatch(readAllNotifications());
        return axios.patch('/api/notifications/read')
            .catch(error => {
                console.error(error);
            });
    };
};